namespace Solovis.Reports.Parameters.Stats {

    export class StatSetBenchmarkRefControl extends Solovis.UI.BaseControl {

        private _benchmarkRef: StatSetOptionsBenchmarkRef;
        private _isRiskFreeRate: boolean;
        private _noRiskFreeRate: boolean;
        private _noFixedRate: boolean;

        private _modeSelectBox: DevExpress.ui.dxSelectBox;

        private _fixedRateDiv: JQuery;
        private _fixedRateInputControl: Solovis.UI.InputControl;
        private _fixedRateCurrencyControl: Solovis.UI.InputControls.ParameterInputControl;

        private _customBenchmarkDiv: JQuery;
        private _customBenchmarkControl: Solovis.UI.InputControls.ParameterInputControl;


        constructor(options) {
            super(options);

            this._benchmarkRef = options.benchmarkRef;
            this._isRiskFreeRate = options.isRiskFreeRate;
            this._noRiskFreeRate = options.noRiskFreeRate;
            this._noFixedRate = options.noFixedRate;
        }


        public doRender() {

            let modeDiv = $("<div>").appendTo(this.container);

            let modeOptions = [];
            modeOptions.push({ text: "None", value: "None" });
            if (!this._isRiskFreeRate) {
                modeOptions.push({ text: "Default Benchmark", value: "DefaultBenchmark" });
            }
            modeOptions.push({ text: "Custom Benchmark", value: "CustomBenchmark" });
            if (!this._noFixedRate) {
                modeOptions.push({ text: "Fixed Annual Rate", value: "FixedAnnualRate" });
            }
            if (!this._isRiskFreeRate && !this._noRiskFreeRate) {
                modeOptions.push({ text: "Risk-Free Rate", value: "RiskFreeRate" });
            }

            let initialMode = "None";
            if (!this._benchmarkRef) {
                if (!this._isRiskFreeRate) {
                    initialMode = "DefaultBenchmark"
                }
                else {
                    initialMode = "None";
                }
            }
            else {
                if (this._benchmarkRef.useDefaultBenchmark) {
                    initialMode = "DefaultBenchmark";
                }
                else if (this._benchmarkRef.useRiskFreeRate) {
                    initialMode = "RiskFreeRate";
                }
                else if (Solovis.isNotNull(this._benchmarkRef.resourceId)) {
                    initialMode = "CustomBenchmark";
                }
                else if (Solovis.isNotNull(this._benchmarkRef.fixedAnnualRate)) {
                    initialMode = "FixedAnnualRate";
                }
            }

            this._modeSelectBox = $(modeDiv).dxSelectBox({
                displayExpr: "text",
                valueExpr: "value",
                dataSource: modeOptions,
                value: initialMode,

                onValueChanged: () => {
                    this._updateControlVisibility();
                }
            }).dxSelectBox("instance");


            let initialFixedRate = null;

            if (this._benchmarkRef && Solovis.isNotNull(this._benchmarkRef.fixedAnnualRate)) {
                // TODO: Process this entirely in string form (requires x100 string support)
                let fixedRateNumber;
                if (typeof this._benchmarkRef.fixedAnnualRate === "number") {
                    fixedRateNumber = this._benchmarkRef.fixedAnnualRate;
                }
                else {
                    fixedRateNumber = parseFloat(this._benchmarkRef.fixedAnnualRate as string);
                }
                if (!isNaN(fixedRateNumber)) {
                    initialFixedRate = fixedRateNumber;
                }
            }

            // Fixed Rate
            this._fixedRateDiv = $("<div>").appendTo(this.container);
            let fixedRateInputDiv = $("<div>").appendTo(this._fixedRateDiv);

            this._fixedRateInputControl = new Solovis.UI.InputControl({
                container: fixedRateInputDiv,
                type: "number",
                showPercentSign: true,
                value: Solovis.isNotNull(initialFixedRate) ? (initialFixedRate * 100.0) : null
            });

            let fixedRateCurrencyDiv = $("<div>").appendTo(fixedRateInputDiv);

            this._fixedRateCurrencyControl = new Solovis.UI.InputControls.ParameterInputControl({
                controlHost: fixedRateCurrencyDiv,
                parameterType: "currency",
                value: (this._benchmarkRef && this._benchmarkRef.fixedRateCurrencyId) ? { id: this._benchmarkRef.fixedRateCurrencyId } : null,
            });
            this._fixedRateCurrencyControl.setAsCurrentControl();

            // Custom Benchmark
            this._customBenchmarkDiv = $("<div>").appendTo(this.container);
            this._customBenchmarkControl = new Solovis.UI.InputControls.ParameterInputControl({
                controlHost: this._customBenchmarkDiv,
                parameterType: "entityOrInvestment",
                value: (this._benchmarkRef && this._benchmarkRef.resourceId) ? { resourceId: this._benchmarkRef.resourceId } : null,
            });
            this._customBenchmarkControl.setAsCurrentControl();

            this._updateControlVisibility();
        }

        private _updateControlVisibility() {
            let mode = this._modeSelectBox.option("value");

            this._fixedRateDiv.toggle(mode === "FixedAnnualRate");
            this._customBenchmarkDiv.toggle(mode === "CustomBenchmark");
        }


        public getBenchmarkRef(): StatSetOptionsBenchmarkRef {
            let mode = this._modeSelectBox.option("value");

            if (mode === "None") {
                return {
                    useNone: true
                };
            }
            else if (mode === "DefaultBenchmark") {
                return {
                    useDefaultBenchmark: true
                };
            }
            else if (mode === "RiskFreeRate") {
                return {
                    useRiskFreeRate: true
                };
            }
            else if (mode === "CustomBenchmark") {
                let customBenchmark = this._customBenchmarkControl.getValue();
                if (customBenchmark) {
                    return {
                        resourceId: customBenchmark.resourceId
                    };
                }
                else {
                    return null;
                }
            }
            else if (mode === "FixedAnnualRate") {
                let fixedRateTimes100 = this._fixedRateInputControl.getValue();
                if (Solovis.isNotNull(fixedRateTimes100)) {
                    let newBenchmarkRef: StatSetOptionsBenchmarkRef = {
                        fixedAnnualRate: fixedRateTimes100 / 100.0
                    };

                    let fixedRateCurrency = this._fixedRateCurrencyControl.getValue();
                    if (fixedRateCurrency) {
                        newBenchmarkRef.fixedRateCurrencyId = fixedRateCurrency.id;
                    }

                    return newBenchmarkRef;
                }
                else {
                    return null;
                }
            }
            else {
                throw "Unexpected mode: " + mode;
            }
        }

    }   

}